import React, { FC } from 'react';
import { ReactComponent as IconFile } from '../../icons/file.svg';
import IMediaItem from '../../interfaces/umbracoNodes/mediaItem';
// import IMediaFolder from '../../interfaces/umbracoNodes/mediaFolder';
import * as StyledMediaList from './mediaList.styles';

interface Props {
	// folder: IMediaFolder;
	folder: IMediaItem;
}

// Componentinn bjost við að fá IMediaFodler sendann inn en einhverja hltua vegna
// var verið að senda inn IMediaItem. Veit ekki hvort að það sé hönnunar galli eða
// það eigi að vera þannig svo ég commentaði bara út kóðan og breytti. Ef þetta brotnar
// útaf því að propsið er IMediaFolder en ekki IMediaItem þá þarf að endurskoða þetta.

const MediaList: FC<Props> = ({ folder }) => {
	return (
		<StyledMediaList.Wrapper>
			{/* {folder.Children &&
				folder.Children.map(mediaItem => (
					<StyledMediaList.MediaItemLink key={mediaItem.Id} href={mediaItem.Src} target="_blank">
						<StyledMediaList.MediaItemName>
							{mediaItem.Name}
							{` (${(mediaItem.Size / 1000000).toFixed(2)} MB)`}
						</StyledMediaList.MediaItemName>
						<IconFile />
					</StyledMediaList.MediaItemLink>
				))} */}
			{folder && (
				<StyledMediaList.MediaItemLink key={folder.Id} href={folder.Src} target="_blank">
					<StyledMediaList.MediaItemName>
						{folder.Name}
						{` (${(folder.Size / 1000000).toFixed(2)} MB)`}
					</StyledMediaList.MediaItemName>
					<IconFile />
				</StyledMediaList.MediaItemLink>
			)}
		</StyledMediaList.Wrapper>
	);
};

export default MediaList;
